import { FilterMultipleOutlineIcon } from './FilterMultipleOutlineIcon';

/**
 * author: Simran
 * id 9124AC57-0F66-4F90-ABF4-167CDA8E46BC
 * name filter-multiple-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-multiple-outline.svg
 * tags
 */
export const FunnelMultipleOutlineIcon = FilterMultipleOutlineIcon;
export default FunnelMultipleOutlineIcon